export interface Report {
  id: number,
  location: string,
  studyUID: string
}

export namespace Report {
  export function sanitize(report: Report): Report {
    return {
      id: report.id,
      location: report.location,
      studyUID: report.studyUID
    }
  }

  export function sanitizeAll(reportList: Report[]): Report[] {
    return reportList.map(r => sanitize(r))
  }
}